var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arrows, Diagrams/more-vertical"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.3895 13C12.9418 13 13.3895 12.5523 13.3895 12C13.3895 11.4477 12.9418 11 12.3895 11C11.8372 11 11.3895 11.4477 11.3895 12C11.3895 12.5523 11.8372 13 12.3895 13Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.3895 6C12.9418 6 13.3895 5.55228 13.3895 5C13.3895 4.44772 12.9418 4 12.3895 4C11.8372 4 11.3895 4.44772 11.3895 5C11.3895 5.55228 11.8372 6 12.3895 6Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.3895 20C12.9418 20 13.3895 19.5523 13.3895 19C13.3895 18.4477 12.9418 18 12.3895 18C11.8372 18 11.3895 18.4477 11.3895 19C11.3895 19.5523 11.8372 20 12.3895 20Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.3a5253aa0bfcc96e24798eecdee5a11c.svg";
export { ForwardRef as ReactComponent };